import React, { useEffect, useState } from "react";
import { getIcon, getControlMeasures } from "./iconDict";
import Colors from "../../colors";
import { Container, Stack } from "@mui/material";
import CorrelatedControlsModal from "../modals/SafetyTailgateModals/CorrelatedControlsModal";


function HazardLabeledIconWithModal({
  name, isEditable,
  selectedHazards, setSelectedHazards,
  selectedControlMeasures, setSelectedHazardsAndControlMeasures }) {
  const [hazardSelected, setHazardSelected] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [checkedControlMeasures, setCheckedControlMeasures] = useState(selectedControlMeasures);
  const [correlatedControlMeasures, setCorrelatedControlMeasures] = useState(getControlMeasures(name));
  const icon = getIcon(name);

  useEffect(() => {
    if (selectedControlMeasures && correlatedControlMeasures.length > 0) {
      const filtered = correlatedControlMeasures.filter(cm => selectedControlMeasures.includes(cm));
      setCheckedControlMeasures(filtered);
    }
  }, [selectedControlMeasures, correlatedControlMeasures]);

  useEffect(() => {
    if (selectedHazards) {
      setHazardSelected(selectedHazards.includes(name));
    }
  }, [name, selectedHazards]);

  const iconOnClick = () => {
    if (isEditable) {
      setModalVisible(true);
    }
  };

  const saveButtonOnClickHandler = (tempCheckedControlMeasures, tempCorrelatedControlMeasures) => {
    // Remove control measures that were unselected
    const prunedMeasures = checkedControlMeasures.filter(cm => !tempCheckedControlMeasures.includes(cm));
    setCheckedControlMeasures(tempCheckedControlMeasures);

    // Combine the mixture of previously selected and the changes from temp
    // Removing ones that were unselected
    const selectedControlMeasuresSet = new Set([...selectedControlMeasures, ...tempCheckedControlMeasures]);
    let combinedSelectedControlMeasures = Array.from(selectedControlMeasuresSet);
    combinedSelectedControlMeasures = combinedSelectedControlMeasures.filter(cm => !prunedMeasures.includes(cm));

    // Update the list of correlated, if any changes
    const correlatedControlMeasuresSet = new Set([...correlatedControlMeasures, ...tempCorrelatedControlMeasures]);
    const combinedCorrelatedControlMeasures = Array.from(correlatedControlMeasuresSet);
    setCorrelatedControlMeasures(combinedCorrelatedControlMeasures);

    // Update list of hazards
    const updatedHazardsSet = new Set([...selectedHazards, name]);
    const updatedHazards = Array.from(updatedHazardsSet);
    if (combinedSelectedControlMeasures.sort() !== selectedControlMeasures.sort()) {
      setSelectedHazardsAndControlMeasures(updatedHazards, combinedSelectedControlMeasures);
    } else {
      if (!hazardSelected) {
        setSelectedHazards(updatedHazards);
      }
    }
    setModalVisible(false);
  };

  const removeHazardOnClickHandler = () => {
    const updatedHazards = selectedHazards.filter(s => s !== name);
    setSelectedHazards(updatedHazards);
    setModalVisible(false);
  };

  return (
    <>
      {/* Labeled Icon */}
      <Stack
        onClick={iconOnClick}
        sx={{
          background: hazardSelected ? Colors.lightGreen : Colors.white,
          textAlign: 'center',
          justifyContent: 'center',
          paddingTop: '15px',
          paddingBottom: '5px',
          boxShadow: '0px 0px 25px -2px rgba(0, 0, 0, 0.1)',
          minHeight: '100px'
        }} >
        <Container>
          {icon}
        </Container>
        <Container sx={{ wordBreak: 'break-word', paddingLeft: '2px', paddingRight: '2px' }}>
          {name}
        </Container>
      </Stack>

      {/* Correlated Control Measures Confirmation Modal */}
      {modalVisible && <CorrelatedControlsModal
        name={name}
        isSelected={hazardSelected}
        isVisible={modalVisible}
        setIsVisible={setModalVisible}
        checkedControlMeasures={checkedControlMeasures}
        correlatedControlMeasures={correlatedControlMeasures}
        saveButtonOnClickHandler={saveButtonOnClickHandler}
        removeButtonOnClickHandler={removeHazardOnClickHandler} />}
    </>
  )
}
export default HazardLabeledIconWithModal;